/**
 * LangChain Logo SVG Component
 *
 * LangChain brand logo - chain/parrot inspired
 */

interface LangChainLogoProps {
  className?: string;
}

export function LangChainLogo({ className }: LangChainLogoProps) {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Chain links forming an abstract pattern */}
      <path
        d="M8 12C8 9.79086 9.79086 8 12 8H14C16.2091 8 18 9.79086 18 12V14C18 16.2091 16.2091 18 14 18H12C9.79086 18 8 16.2091 8 14V12Z"
        fill="url(#langchain-gradient-1)"
      />
      <path
        d="M14 14C14 11.7909 15.7909 10 18 10H20C22.2091 10 24 11.7909 24 14V20C24 22.2091 22.2091 24 20 24H18C15.7909 24 14 22.2091 14 20V14Z"
        fill="url(#langchain-gradient-2)"
      />
      {/* Connector */}
      <rect x="12" y="13" width="8" height="3" rx="1.5" fill="#1C3C3C" />
      {/* Parrot eye hint */}
      <circle cx="11" cy="12" r="1.5" fill="#FFFFFF" />
      <circle cx="11" cy="12" r="0.75" fill="#1C3C3C" />
      <defs>
        <linearGradient
          id="langchain-gradient-1"
          x1="8"
          y1="8"
          x2="18"
          y2="18"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1C3C3C" />
          <stop offset="1" stopColor="#2D5A5A" />
        </linearGradient>
        <linearGradient
          id="langchain-gradient-2"
          x1="14"
          y1="10"
          x2="24"
          y2="24"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3D7A7A" />
          <stop offset="1" stopColor="#1C3C3C" />
        </linearGradient>
      </defs>
    </svg>
  );
}
